export const getIndices = (state) => state.pressaoBiodiversidade.indices
export const getIsLoading = (state) => state.pressaoBiodiversidade.isLoading
export const getAnoCarregado = (state) => state.pressaoBiodiversidade.anoCarregado
